// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table-emptyImg .empty[data-v-52a1c288]{width:150px;height:150px;margin-top:80px;margin-bottom:0}", ""]);
// Exports
module.exports = exports;
